module.exports = __webpack_public_path__ + "static/q3-ecda1c96b9113d711032589a27dc901d.png";